<template>
	<div style="text-align:center;">
		<el-row :gutter="10" >
			<el-col :xs="24" :sm="12" :md="6" :lg="6" :xl="6">
				<el-card id="status" 
					:body-style="{ padding: '0px' }" 
					class="bg-success text-grey"
					style="margin-top: 5px;margin-bottom: 5px;"
					>
					<p><br></p>
					<i class="fas fa-user"></i>
					<p>Estatus del Tutor</p>
				</el-card>
			</el-col>
			<el-col :xs="24" :sm="12" :md="6" :lg="6" :xl="6">
				<el-card id="plans" 
					:body-style="{ padding: '0px' }" 
					class="bg-success text-grey"
					style="margin-top: 5px;margin-bottom: 5px;"
					>
					<p><br></p>
					<i class="fas fa-file-alt"></i>
					<p>Mis planes de capacitación</p>
				</el-card>
			</el-col>
			<el-col :xs="24" :sm="12" :md="6" :lg="6" :xl="6">
				<el-card id="youngs" 
					:body-style="{ padding: '0px' }" 
					class="bg-success text-grey"
					style="margin-top: 5px;margin-bottom: 5px;"
					>
					<p><br></p>
					<i class="fas fa-users"></i>
					<p>Mis becarios</p>
				</el-card>
			</el-col>			
			<el-col :xs="24" :sm="12" :md="6" :lg="6" :xl="6">
				<el-card id="evaluations" 
					:body-style="{ padding: '0px' }" 
					class="bg-success text-grey"
					style="margin-top: 5px;margin-bottom: 5px;"
					>
					<p><br></p>
					<i class="fas fa-user-edit"></i>
					<p>Evaluaciones</p>
				</el-card>
			</el-col>
			<el-col :xs="24" :sm="12" :md="6" :lg="6" :xl="6">
				<el-card id="historic-evaluations" 
					:body-style="{ padding: '0px' }" 
					class="bg-success text-grey"
					style="margin-top: 5px;margin-bottom: 5px;"
					>
					<p><br></p>
					<i class="fas fa-file-alt"></i>
					<p>Histórico de evaluaciones</p>
				</el-card>
			</el-col>
			<el-col :xs="24" :sm="12" :md="6" :lg="6" :xl="6">
					<el-card @click.native="goRedirect('/correos/mensajes-no-leidos')"
					         :body-style="{ padding: '0px' }"
					         class="bg-success text-grey"
							 style="margin-top: 5px;margin-bottom: 5px;"
					         shadow="never">
						<div class="text-middle all-padding">
							<i class="fas fa-envelope"></i>
							<p>Mensajes no leidos</p>
						</div>
					</el-card>
			</el-col>
			<el-col :xs="24" :sm="12" :md="6" :lg="6" :xl="6" >
					<el-card @click.native="goRedirect('/correos/historico-de-mensajes')"
					         :body-style="{ padding: '0px' }"
					         class="bg-success text-grey"
							 style="margin-top: 5px;margin-bottom: 5px;"
					         shadow="never">
						<div class="text-middle all-padding">
							<i class="fas fa-envelope-open-text"></i>
							<p>Historico de Mensajes</p>
						</div>
					</el-card>
				</el-col>
				<el-col :xs="24" :sm="12" :md="6" :lg="6" :xl="6">
					<el-card @click.native="goRedirect('/instructor/becarios-con-capacitacion-concluida')"
					         :body-style="{ padding: '0px' }"
					         class="bg-success text-grey"
							 style="margin-top: 5px;margin-bottom: 5px;"
					         shadow="never">
							<div class="text-middle all-padding">
							<i class="fas fa-user-graduate"></i>
							<p>Becarios con Capacitación Concluida</p>
						</div>
					</el-card>
				</el-col>
		</el-row>
		<br>
	</div>
</template>
<script>
	import {InstructorMix} from '@/mixins/advisor/Instructor';

	import { mapState, mapGetters, mapActions, mapMutations } from "vuex";


	export default {
		mixins: [InstructorMix],
		components: {},
		methods: {

			sectionStatus() {
				this.$router.push('/instructor/estatus');
			},
			sectionPlans() {
				this.$router.push('/instructor/planes');
			},
			sectionEvaluations() {
				this.$router.push('/instructor/evaluaciones');
			},
			sectionHistoricEvaluations() {
				this.$router.push('/instructor/historico-evaluaciones');
			},		
			sectionInstructorYoungs() {
				this.$router.push('/instructor/becarios');
			},	
			goRedirect(url) {
				this.$router.push(url);
			}



		},
		mounted() {

			document.getElementById('status').addEventListener("click", this.sectionStatus);
			document.getElementById('plans').addEventListener("click", this.sectionPlans);
			document.getElementById('evaluations').addEventListener("click", this.sectionEvaluations);
			document.getElementById('historic-evaluations').addEventListener("click", this.sectionHistoricEvaluations);
			document.getElementById('youngs').addEventListener("click", this.sectionInstructorYoungs);

		},
		data() {
			return {

			}
		},
		computed: {},
	}
</script>

<style scoped>
	.el-card {
		min-height: 150px;
		cursor: pointer;
	}
	.bg-success {
		background-color: #fdf9f6;
	}

	.text-white {
		color: white
	}

</style>